module.exports = __webpack_public_path__ + "img/74.bbb8ac1b.jpg";